export const DialogInjectionKey = Symbol();
